webpackJsonp([13],{

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(775),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_graphql__ = __webpack_require__(139);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var SnackBar = function SnackBar() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 285));
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      step: 1,
      snackbarColor: '',
      name: '',
      email: '',
      password: '',
      showPassword: false,
      phone: '+549',
      errorText: '',
      showErrorMissingData: false,
      selectedRole: '',
      allRoles: [],
      validStep1: '',
      validStep2: ''
    };
  },

  apollo: {
    allRoles: {
      query: __WEBPACK_IMPORTED_MODULE_0__constants_graphql__["m" /* ALL_ROLES_QUERY */]
    }
  },
  mounted: function mounted() {
    this.$router.push('/signup');
    this.step = 1;
    this.$store.commit('setStep', 1);
    this.$store.commit('setShowStepSignup', true);
  },

  computed: {
    isFirstStep: function isFirstStep() {
      return this.step === 1;
    },
    currentRoute: function currentRoute() {
      return this.$router.currentRoute.fullPath;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.fullPath === '/signup') {
        this.$store.commit('setStep', 1);
        this.step = 1;
      };
    }
  },
  methods: {
    onContinue: function onContinue() {
      if (this.validStep1) {
        this.$store.commit('setStep', 2);
        this.step = 2;
        this.$router.push('/signup2');
      } else {
        this.snackbarColor = 'red';
        this.errorText = 'Por favor complete correctamente sus datos.';
        this.showErrorMissingData = true;
      }
    },
    saveUserData: function saveUserData(id, email, token) {
      localStorage.setItem('auth_token', token);
      this.$root.$data.userId = id;
      this.$store.dispatch('signUserIn', { id: id, email: email, token: token });
    },
    onSignup: function onSignup() {
      var _this = this;

      if (!this.$store.getters.isOnline) {
        this.snackbarColor = 'red';
        this.errorText = 'Sin conexión! Intenta nuevamente más tarde';
        this.showErrorMissingData = true;
        return;
      }
      if (!this.validStep2) {
        this.snackbarColor = 'red';
        this.errorText = 'Por favor complete correctamente sus datos.';
        this.showErrorMissingData = true;
        return;
      }
      var _$data = this.$data,
          name = _$data.name,
          email = _$data.email,
          password = _$data.password,
          phone = _$data.phone;

      var variables = { name: name, email: email, password: password, phone: phone };
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_0__constants_graphql__["A" /* CREATE_USER_MUTATION */],
        variables: variables
      }).then(function (result) {
        var id = result.data.authenticate.item.id;
        var token = result.data.authenticate.token;
        _this.saveUserData(id, email, token);
        if (_this.selectedRole !== '') {
          _this.$apollo.mutate({
            mutation: __WEBPACK_IMPORTED_MODULE_0__constants_graphql__["o" /* UPDATE_USER_ROLE_MUTATION */],
            variables: {
              userId: id,
              roleId: _this.selectedRole
            }
          }).then(function () {
            _this.$router.push({ name: 'UserInfo', params: { firstEntry: true } });
          }).catch(function () {
            _this.snackbarColor = 'red';
            _this.errorText = 'Server Error';
            _this.showErrorMissingData = true;
          });
        } else {
          _this.$router.push({ name: 'UserInfo', params: { firstEntry: true } });
        }
        _this.$store.commit('setShowStepSignup', false);
      }).catch(function (error) {
        _this.errorText = 'Server error  ';
        if (error.graphQLErrors && error.graphQLErrors[0] && error.graphQLErrors[0].extensions.exception.constraint) {
          _this.errorText = 'El email ingresado ya se encuentra en uso';
        }
        _this.snackbarColor = 'red';
        _this.showErrorMissingData = true;
      });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  },
  components: {
    'snackbar': SnackBar
  }
});

/***/ }),

/***/ 775:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "sign-up"
  }, [(_vm.error) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('app-alert', {
    attrs: {
      "text": _vm.error.message
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isFirstStep) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('snackbar', {
    attrs: {
      "text": _vm.errorText,
      "color": _vm.snackbarColor,
      "show": _vm.showErrorMissingData,
      "timeOut": 2000
    },
    on: {
      "update:show": function($event) {
        _vm.showErrorMissingData = $event
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Creá tu cuenta")]), _vm._v(" "), _c('v-container', [_c('v-form', {
    model: {
      value: (_vm.validStep1),
      callback: function($$v) {
        _vm.validStep1 = $$v
      },
      expression: "validStep1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "face",
      "name": "name",
      "label": "Nombre y Apellido",
      "id": "name",
      "type": "name",
      "rules": _vm.$ponceConfig.requiredRules,
      "required": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "padding",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "email",
      "name": "email",
      "label": "Email",
      "id": "email",
      "type": "email",
      "rules": _vm.$ponceConfig.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "padding"
  }, [_vm._v("Definí tu rol")]), _vm._v(" "), _c('v-container', [_c('v-select', {
    attrs: {
      "label": "Rol",
      "prepend-icon": "person",
      "item-text": "label",
      "item-value": "id",
      "items": _vm.allRoles
    },
    model: {
      value: (_vm.selectedRole),
      callback: function($$v) {
        _vm.selectedRole = $$v
      },
      expression: "selectedRole"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "create-button",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onContinue()
      }
    }
  }, [_vm._v("Continuar")])], 1)], 1)], 1)], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('snackbar', {
    attrs: {
      "text": _vm.errorText,
      "color": _vm.snackbarColor,
      "show": _vm.showErrorMissingData,
      "timeOut": 2000
    },
    on: {
      "update:show": function($event) {
        _vm.showErrorMissingData = $event
      }
    }
  }), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.validStep2),
      callback: function($$v) {
        _vm.validStep2 = $$v
      },
      expression: "validStep2"
    }
  }, [_c('h2', [_vm._v("Establecé tu contraseña")]), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "lock",
      "name": "password",
      "label": "Contraseña",
      "id": "password",
      "type": _vm.showPassword ? 'text' : 'password',
      "append-icon": _vm.showPassword ? 'visibility_off' : 'visibility',
      "rules": _vm.$ponceConfig.passwordRules,
      "required": ""
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "padding"
  }, [_vm._v("Validación")]), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "phone",
      "name": "phoneNumber",
      "id": "phoneNumber",
      "label": "ej: +549223XXXXXXX",
      "type": "phoneNumber",
      "rules": _vm.$ponceConfig.phoneRules,
      "required": ""
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "create-button",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.onSignup
    }
  }, [_vm._v("Crear cuenta")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.c05cf0fd9d4674891de1.js